"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _AutoComplete = _interopRequireDefault(require("../AutoComplete"));

var _index = _interopRequireDefault(require("../AutoCompleteGooglePlaces/index"));

var _style = _interopRequireDefault(require("./style"));

var _Select = _interopRequireDefault(require("../../dist/Select"));

var _react2 = require("@emotion/react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const PAIS = 'id_pais';
const PROVINCIA = 'id_provincia';
const LOCALIDAD = 'id_localidad';
const DIRECCION = 'direccion';
const GOOGLE_PLACE = 'google_place_id';

class FormUbicacion extends _react.default.Component {
  constructor(props) {
    super(props);
    this.onChangeValueSelected = this.onChangeValueSelected.bind(this);
    this.onChangeValue = this.onChangeValue.bind(this);
    this.handleChangeProvincia = this.handleChangeProvincia.bind(this);
  }

  onChangeValueSelected(nameValue, suggestion) {
    this.props.onChange(nameValue, suggestion);
  }

  onChangeValue(nameValue, value) {
    this.props.onChangeValue(nameValue, value);
  }

  handleChangeProvincia(e) {
    this.props.onChange(PROVINCIA, e.target);
  }

  render() {
    const {
      paises,
      provincias,
      id_pais,
      localidades,
      id_provincia,
      id_localidad,
      codigo_pais,
      test,
      direccion
    } = this.props;
    const esExterior = !!id_pais && id_pais != 1;
    const mostrarPais = paises && paises.length;
    const mostrarProvincia = !esExterior && provincias && provincias.length;
    const mostrarLocalidad = !esExterior;
    const localidadCargando = id_localidad && (!localidades || !localidades.length);
    const id_pais_aux = id_pais ? id_pais : 1;
    const valueLocalidadForGoogle = _.chain(localidades).find(localidadMap => localidadMap.value == id_localidad).get('label').value() || '';
    let inputLocalidad = mostrarLocalidad ? (0, _react2.jsx)(_AutoComplete.default, {
      suggestions: localidades,
      selected: id_localidad,
      cantResultados: this.props.cantResultadosLocalidad,
      placeHolder: 'Localidad',
      disabled: !id_provincia,
      onSuggestionSelected: (event, {
        suggestion
      }) => this.onChangeValueSelected(LOCALIDAD, suggestion),
      onChange: value => this.props.onChangeValue(LOCALIDAD, value)
    }) : null;
    return (0, _react2.jsx)("div", null, (0, _react2.jsx)(_material.Grid, {
      container: true,
      direction: "column"
    }, (0, _react2.jsx)(_material.Grid, {
      item: true,
      xs: 12
    }, (0, _react2.jsx)(_material.Grid, {
      container: true,
      direction: 'column'
    }, mostrarPais ? (0, _react2.jsx)(_AutoComplete.default, {
      suggestions: paises,
      selected: id_pais_aux,
      cantResultados: this.props.cantResultadosPais,
      placeHolder: 'País',
      onSuggestionSelected: (event, {
        suggestion
      }) => this.onChangeValueSelected(PAIS, suggestion),
      onChange: value => this.props.onChangeValue(PAIS, value)
    }) : null, mostrarProvincia ? (0, _react2.jsx)(_Select.default, {
      name: "provincia",
      placeholder: "Provincia",
      value: id_provincia !== null ? id_provincia : '',
      onChange: this.handleChangeProvincia,
      nameOfTheKeyWithTheValue: "value",
      nameOfTheKeyWithTheLabel: "label",
      data: provincias,
      campo: "provincia"
    }) : null, !localidadCargando ? inputLocalidad // : <div style={{ margin: '24px 8px 8px 8px'}}><div css={style.skeleton} style={{height: 48 }}/></div>
    : (0, _react2.jsx)(_material.Skeleton, {
      style: {
        margin: '24px 8px 8px 8px'
      },
      animation: "wave",
      variant: "rect",
      height: 32
    }), esExterior ? (0, _react2.jsx)(_index.default, {
      value: valueLocalidadForGoogle,
      test: test,
      codigoPais: codigo_pais,
      onSuggestionSelected: (event, {
        suggestion
      }) => this.onChangeValueSelected(GOOGLE_PLACE, suggestion)
    }) : null)), (0, _react2.jsx)(_material.Grid, {
      item: true,
      css: _style.default.direccionInput
    }, (0, _react2.jsx)(_material.TextField, {
      variant: "standard",
      label: "Direcci\xF3n",
      name: "direccion",
      defaultValue: direccion,
      onBlur: e => this.props.onChangeValue(DIRECCION, e.target.value),
      fullWidth: true,
      autoComplete: "none"
    }))));
  }

}

var _default = FormUbicacion;
exports.default = _default;